module.exports = "/build/web/svg/social/default/instagram.8e7a03d3bb9c184c6aafdc1d5e3f3ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/default/instagram.svg
// module id = 183
// module chunks = 24